import { TApplicationState } from '../../types/redux';

export const selectFormSecondsToRetry = (state: TApplicationState) => {
  return state.requestFormV2.phoneVerification.secondsToRetry;
};
